export default __webpack_public_path__ + "71af3be393d8d4e90892195e78295e0a.svg";